import React from "react";
import cx from "classnames";
import { useUIDSeed } from "react-uid";
import { Body } from "../../atoms";
import { twMerge } from "../../../utils";
export function NavigationList(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "list" : _variant, items = param.items, className = param.className;
    var seed = useUIDSeed();
    return /*#__PURE__*/ React.createElement("ul", {
        className: cx("not-prose grid grid-cols-1 grid-flow-row auto-rows-max", variant === "list" && "gap-4", className)
    }, items.map(function(item) {
        return /*#__PURE__*/ React.createElement("li", {
            key: seed(item),
            className: twMerge(cx("flex pl-0 md:grid", "items-center transition-all md:grid-cols-[auto_1fr]", "before:hidden before:transition-all before:w-[1.25rem] before:h-1 before:bg-brand-primary-base md:before:block", variant === "list" && cx("md:gap-5 hover:before:bg-brand-primary-light hover:before:w-[1.6em] hover:text-brand-primary-light", item.active && "text-brand-primary-light before:bg-brand-primary-light before:w-[1.6em]"), variant === "sections" && cx("md:opacity-30 md:gap-7 py-2 before:w-1 before:-my-2 before:h-auto before:self-stretch before:bg-fg-default", "md:hover:before:bg-fg-default md:hover:opacity-100", item.active && "md:opacity-100")))
        }, /*#__PURE__*/ React.createElement("button", {
            type: "button",
            className: "mx-auto px-5 py-3 bg-bg-offdefault md:px-0 md:py-0 md:bg-transparent md:mx-0 md:text-left",
            onClick: item.onClick
        }, /*#__PURE__*/ React.createElement(Body, {
            variant: "big"
        }, item.label)));
    }));
}

//# sourceMappingURL=NavigationList.js.map